var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHostelWhite = function SvgHostelWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M4.974 23.235v-6.69m19.4-7.359-6.021-6.69-6.021 6.69v13.38h12.042zm-4.014 7.36c0-1.018-.782-2.008-2.006-2.008-1.225 0-2.007.963-2.007 2.007v6.02h4.013zM4.974 10.524a3.345 3.345 0 0 1 3.345 3.344v2.676a3.345 3.345 0 0 1-6.69 0V13.87a3.345 3.345 0 0 1 3.345-3.344Z"
  })));
};
export default SvgHostelWhite;